module.exports = __webpack_public_path__ + "static/media/Icon ionic-md-close-white.579ab13e.svg";